<template>
  <div>

    <PageTitleBar
      parent="Institute Dashboard"
      title="Staff / Student List"
      icon="fas fa-users fa-2x mb-2 text-primary"
    />

    <!-- Profile Modal -->
    <b-modal
      id="instituitionProfile"
      :title="selectedInstitute.name || ''"
      no-close-on-backdrop
      no-close-on-keyboard
      no-close-on-esc
      hide-header-close
      hide-footer
      modal-class="instituitionProfile"
    >
      <instituition-user-profile
        ref="userProfile"
        :userId="userId"
        :institutionUsersList="institutionUsersList"
        :institution_users="institution_users"
        :institutionUsersObject="institutionUsersObject"
        @profilesFinished="profilesFinished"
      ></instituition-user-profile>
    </b-modal>

    <b-modal id="viewStudentProfile" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
      modal-class="usersListPendingFull">
      <ViewProfile :institutionUserId="institutionUserId" :from_staff_student_list="true"/>
    </b-modal>

    <b-modal id="viewFacultyProfile" no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-footer
      modal-class="usersListPendingFull">
      <MyProfileNew :institutionUserId="institutionUserId" :profile_id="profileId"/>
    </b-modal>


    <!-- Loading -->
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>

    <!-- Main content -->
    <div v-else class="usersListPending p-1">
      <div>
        <!-- Invite -->
        <institute-invite
          v-if="inviteInstitutionUsers"
          ref="inviteUsers"
          :selectedInstitute="selectedInstitute"
          @invitationClosed="inviteInstitutionUsers = false"
        ></institute-invite>

        <!-- Action bar -->
        <div class="d-flex justify-content-between align-items-center p-2 border-top border-bottom">
          <div class="d-flex align-items-center">
            <b-button variant="info" size="sm" @click="institutionUsers">
              <i class="fas fa-sync-alt"></i>
            </b-button>

            <b-button variant="info" size="sm" class="ml-2" @click="inviteUsers">
              <i class="fas fa-user-plus"></i> Invite
            </b-button>
          </div>

          <div class="d-flex align-items-center">
            <div class="input-group input-group-sm mr-2" style="width: 250px;">
              <b-form-input
                v-model="searchQuery"
                placeholder="Search by name / username / role"
                @keyup.enter="performSearch"
              ></b-form-input>

              <div class="input-group-append">
                <b-button
                  variant="outline-secondary"
                  @click="performSearch"
                >
                  <i class="fas fa-search text-primary"></i>
                </b-button>
              </div>
            </div>

            <b-button variant="danger" size="sm" @click="clearSearch">
              Clear
            </b-button>
          </div>
        </div>

        <!-- Controls -->
        <b-form-group class="my-2 p-0">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <b-form-checkbox
                size="md"
                v-model="allUsersSelected"
                @change="toggleAll"
                :indeterminate="indeterminate"
              >
                {{ allUsersSelected ? "Un-select All" : "Select All" }}
              </b-form-checkbox>

              <b-button
                variant="danger"
                size="sm"
                class="ml-2"
                @click="updateUsersEnrollStatus('blocked')"
                :disabled="!enableEnrollStatusBtn"
              >
                {{ enableEnrollStatusBtn ? "Deactivate" : "Working..." }}
              </b-button>

              <b-button
                variant="success"
                size="sm"
                class="ml-2"
                @click="updateUsersEnrollStatus('active')"
                :disabled="!enableEnrollStatusBtn"
              >
                {{ enableEnrollStatusBtn ? "Activate" : "Working..." }}
              </b-button>

              <b-button variant="info" size="sm" class="ml-2" @click="createProfile">
                View/Edit
              </b-button>
            </div>

            <p class="m-0 p-1 bg-success text-white rounded small">
              Users:
              <span v-if="searchQuery">{{ institutionUsersList.length }}/</span>{{ totalUsers }}
            </p>
          </div>
        </b-form-group>

        <!-- Error -->
        <span class="text-danger small" v-if="responseErrors.institution_users">
          {{ responseErrors.institution_users[0] }}
        </span>

        <!-- Success -->
        <span class="text-success small" v-if="approveSuccess">
          {{ institution_users.length > 1 ? "Users Approved" : "User Approved" }}
        </span>

        <!-- Table -->
        <table class="table table-striped table-bordered" id="usersPendingTable">
          <thead class="thead-dark text-left">
            <tr>
              <th></th>
              <th>Name</th>
              <th>Username</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Guardian</th>
              <th>Role</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(users, idx) in institutionUsersList" :key="idx">
              <td>
                <b-form-checkbox v-model="institution_users" :value="users.id" size="sm"></b-form-checkbox>
              </td>

              <td>
              <!-- users.user.id  {{ users.user ? users.user.id:null   }} <br>
              users.id {{ users.id }} -->
                <span 
                  class="btn p-0 m-0 text-info font-weight-bolder text-capitalize"
                  @click="goToUserProfile('UserProfile', users.user ? users.user.id : 0, users.id, users.institution_role.name)"
                >
                  {{ users.first_name || '' }} {{ users.last_name || '' }}
                </span>

                <b-badge v-if="users.enroll_status !== 'active'" variant="danger" class="ml-2">Deactivated</b-badge>

                <b-badge
                  v-if="!users.user"
                  @click="resendInvitation(users.id)"
                  variant="info"
                  class="ml-2"
                  style="cursor: pointer;"
                >
                  Resend
                </b-badge>
              </td>

              <td>
                {{ users.user ? users.user.username : '' }}
                <b-badge v-if="!users.user" variant="warning" class="ml-2">unenrolled</b-badge>
              </td>

              <td>{{ users.user ? users.user.email : users.email }}</td>
              <td>{{ users.user ? users.user.mobile : users.mobile }}</td>
              <td>{{ users.guardian_mobile }}</td>
              <td>{{ roleNames[users.institution_role.name] || users.institution_role.name }}</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-center mt-3">
          <!-- <b-pagination
            v-model="currentPage"
            :total-rows="filteredUsers.length"
            :per-page="15"
            @input="paginate"
          ></b-pagination> -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            @input="institutionUsers"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyProfileNew from "@/components/templates/Dashboard/myprofile/MyProfileNew.vue";
import axios from "axios";
//import InstituteCardView from "../InstituteCardView.vue";
import InstituitionUserProfile from "./InstituitionUserProfile.vue";
import InstituteInvite from "../invite/InstituitionInvite.vue";
import ViewProfile from "@/components/templates/Dashboard/Institute/usergroups/usersubgroups/subgroup_users_edit/ViewProfile.vue";
import PageTitleBar from
  "@/components/templates/Dashboard/Institute/PageTitleBar.vue";

export default {
  components: {
    MyProfileNew,
    //instituteCardView: InstituteCardView,
    InstituitionUserProfile,
    "institute-invite": InstituteInvite,
    ViewProfile,
    PageTitleBar
  },
  // props: ["selectedInstitute"],

  data() {
    return {
      inviteInstitutionUsers: false,
      fetchData: false,
      institutionUsersList: [],
      totalRows: 0,
      totalUsers: 0,
      institutionUsersObject: {},
      institution_users: [],
      searchQuery: "",
      currentPage: 1,
      perPage: 15,
      allUsersSelected: false,
      indeterminate: false,
      userId: null,
      enableEnrollStatusBtn: true,
      responseErrors: {},
      approveSuccess: false,
      roleNames: { admin: "Admin", teacher: "Faculty", student: "Student", account_supervisor: "Account Supervisor", accounts_manager: "Accounts Manager", admission_coordinator: "Admission Coordinator", hr: "HR", coe: "COE", librarian: "Librarian", principal: "Principal" },
      institutionUserId: null,
      profileId: null,
    };
  },

   computed: {
    selectedInstitute() {
      return this.$store.getters.getCurrentInstitution;
    },
  //   filteredUsers() {
  //     const q = this.searchQuery.toLowerCase();

  //     return this.institutionUsersList.filter((user) => {

  //       let name = (
  //         user.first_name +
  //         " " +
  //         (user.last_name || "")
  //       ).toLowerCase();

  //       let username = user.user ? user.user.username.toLowerCase() : "";

  //       // raw role from API
  //       let rawRole = user.institution_role && user.institution_role.name
  //         ? user.institution_role.name.toLowerCase()
  //         : "";

  //       // mapped role shown in UI
  //       let mappedRole = this.roleNames[user.institution_role.name]
  //         ? this.roleNames[user.institution_role.name].toLowerCase()
  //         : rawRole;

  //       return (
  //         name.includes(q) ||
  //         username.includes(q) ||
  //         rawRole.includes(q) ||
  //         mappedRole.includes(q)
  //       );
  //     });
  //   },


  //   displayedUsers() {
  //     const start = (this.currentPage - 1) * this.perPage;
  //     return this.filteredUsers.slice(start, start + this.perPage);
  //   },
   },

  methods: {
    // clearSearch() {
    //   this.searchQuery = "";
    //   this.currentPage = 1;
    //   this.institutionUsers(); // reload
    // },
    performSearch() {
      this.currentPage = 1;
      this.institutionUsers();
    },

    clearSearch() {
      this.searchQuery = "";
      this.currentPage = 1;
      this.institutionUsers();
    },


    paginate() {},

    async inviteUsers() {
      this.inviteInstitutionUsers = true;
      await this.$refs.inviteUsers.prepareInviteUsers();
    },

    toggleAll(checked) {
      this.institution_users = checked
        ? this.institutionUsersList.map(u => u.id)
        : [];
    },

    createProfile() {
      this.$bvModal.show("instituitionProfile");
    },

    profilesFinished() {
      this.userId = null;
      this.institution_users = [];
      this.$bvModal.hide("instituitionProfile");
    },

    // async institutionUsers() {
    //   this.fetchData = true;

    //   const url = 
    //   this.$store.getters.getAPIKey.mainAPI +
    //     `/institutionusers/staffstudentlist`;

    //   try {
    //     const response = await axios.get(url);
    //     this.institutionUsersList = response.data;

    //     this.institutionUsersObject = {};
    //     this.institutionUsersList.forEach((u) => {
    //       this.$set(this.institutionUsersObject, u.id, u);
    //     });
    //   } catch (e) {e;}
    //   this.fetchData = false;
    // },
    async institutionUsers(page = this.currentPage) {
      this.currentPage = page;   
      this.fetchData = true;

      const url =
        this.$store.getters.getAPIKey.mainAPI + `/institutionusers/staffstudentlist`;

      try {
        const response = await axios.post(url, 
         {
            page: this.currentPage,
            per_page: this.perPage,
            search: this.searchQuery
          }
        );

        this.institutionUsersList = response.data.data;
        this.institutionUsersObject = {};
        this.institutionUsersList.forEach((u) => {
          this.$set(this.institutionUsersObject, u.id, u);
        });
        this.totalRows = response.data.total;

        if(!this.searchQuery){
          this.totalUsers = response.data.total;
        }

      } catch (e) {
        console.error(e);
      }

      this.fetchData = false;
    },



    resendInvitation(id) {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/${id}/invitation/resent`;
      this.$axios
        .get(url)
        .then(() => this.$toast.success(`Enrollment code sent successfully`))
        .catch(() => this.$toast.error(`Failed to send enrollment code`));
    },

    updateUsersEnrollStatus(status) {
      this.enableEnrollStatusBtn = false;

      const url =
        this.$store.getters.getAPIKey.mainAPI + "/institutionusers/enroll_status";

      axios
        .post(url, {
          institution_users: this.institution_users,
          enroll_status: status,
        })
        .then(() => {
          this.$toast.success("Enroll status updated");
          this.institution_users = [];
          this.institutionUsers();
        })
        .catch(() => this.$toast.error("Failed to update status"))
        .finally(() => (this.enableEnrollStatusBtn = true));
    },

    goToUserProfile(path, profileId, institution_user_id, role) {
      this.institutionUserId = institution_user_id;
      this.profileId = profileId ?? 0;
      if (role === "Student" || role === "student") {
        
        this.$bvModal.show("viewStudentProfile");
        
        // this.$root.subContent.subContentComponent = "ViewProfile";
        // this.$root.subContent.subContentData = {
        //   groupInfo: null,
        //   institutionUserId: profileId,
        //   sortByOrder: null,
        // };
        // this.$root.subContent.enableMainContent = false;
      } else {
        // let routeData = this.$router.resolve({
        //   name: "MyProfileNewFromStudentStaffList",
        //   params: { profileId,
        //     institution_user_id
        //    },
        // });
        // window.open(routeData.href, "_blank");

        this.$bvModal.show("viewFacultyProfile");
      }
    },
  },

  async created() {
    await this.institutionUsers();
  },
};
</script>

<style>
.usersListPending i {
  font-size: 12px !important;
}
</style>
